import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {AuthService} from '../../common/auth.service';
import {OtpService} from '../otp.service';
import {UserDetailsService} from '../../common/user-details.service';
import {OtpScreen} from '../otp';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'otp-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['verify.component.scss'],
})
export class OtpVerifyComponent implements OnInit {
  public otpVerifyForm: FormGroup;
  public formControlNames: string[] = [];

  constructor(
    public authService: AuthService,
    public otpService: OtpService,
    public userDetailsService: UserDetailsService,
    protected router: Router,
    protected route: ActivatedRoute
  ) {
  }

  public ngOnInit(): void {
    this.otpService.otpCode = '';
    this.otpVerifyForm = new FormGroup({});
    for (let i = 0; i < this.otpService.otpCodeLength; i++) {
      let formControlName = 'otpCode' + i;
      this.formControlNames.push(formControlName);
      this.otpVerifyForm.addControl(formControlName, new FormControl(''));
    }
    this.enableForm();
    this.clearFormError();
  }

  public setFormError(): void {
    this.formControlNames.forEach(formControlName => {
      let formControl = this.otpVerifyForm.get(formControlName);
      formControl.markAsTouched();
      formControl.markAsDirty();
      formControl.setErrors({'incorrect': true});
    });
  }

  public clearFormError(): void {
    this.formControlNames.forEach(formControlName => {
      this.otpVerifyForm.get(formControlName).setErrors(null);
    });
  }

  protected disableForm(): void {
    this.formControlNames.forEach(formControlName => {
      this.otpVerifyForm.get(formControlName).disable();
    });
  }

  protected enableForm(): void {
    this.formControlNames.forEach(formControlName => {
      this.otpVerifyForm.get(formControlName).enable();
    });
  }

  public verifyOtp(): void {
    this.clearFormError();
    this.disableForm();
    this.otpService.validateOtpSms(async (otpValidateTokenResponse) => {
      if (this.authService.authenticated && this.otpService.passed) {
        await this.userDetailsService.checkIfFirstTime();
        if (!this.userDetailsService.commonDataService.isFirstTimeLogin) {
          await this.userDetailsService.setUpCustomerDetails();
          this.authService.canActivateNavigationCallback(this.route.snapshot, this.router.routerState.snapshot);
        }
      } else {
        this.enableForm();
        this.setFormError();
      }
    });
  }

  public resend(): void {
    this.otpService.currentScreen = OtpScreen.RESEND;
  }

  public back(): void {
    this.otpService.currentScreen = OtpScreen.SEND;
  }
}
